import { each } from 'lodash/each'
import { app } from '../utils/store'

import gsap from 'gsap'

class Privacy {
    async create(entry) {
        // let modal = document.getElementById('modal-privacy')
        // let exists = document.body.contains(modal)

        // console.log(init, modal, exists, app.bundle)

        // if (exists && !init) { return } 
        // else {
            let cookieconsent = '<script id="CookieDeclaration" src="https://consent.cookiebot.com/d9232608-24a6-4be3-91f5-85bf7e33cc36/cd.js" type="text/javascript" async></script>'

            this.toggler = entry
            this.href = entry.href

            const request = await window.fetch(this.href)

            if (request.status === 200) {
                let response = await request.text()
                response = (response
                    .replace('<body', '<fragment'))
                    .replace('body>', 'fragment>')

                // Set request Result
                this.request = {
                    html: response,
                    fragment: document.createElement('fragment')
                }

                this.request.fragment.innerHTML = this.request.html
                this.wrapper = this.request.fragment.querySelector('[data-wrapper]')

                if(this.wrapper){
                    this.content = this.wrapper.querySelector('.container.body .content').innerHTML
                    
                    this.modal = {
                        section: document.createElement('section'),
                        closer: document.createElement('button'),
                        content: document.createElement('div')
                    }

                    // Create::Section
                    this.modal.section.id = 'modal-privacy'
                    this.modal.section.className = 'modal'
                    this.modal.section.setAttribute('data-modal','')
                    
                    // Create::Closer
                    this.modal.closer.className = 'btn-closer'
                    this.modal.closer.setAttribute('data-modal-close','')
                    this.modal.closer.innerHTML = `<span class="visually-hidden">Chiudi</span>`

                    // Create::Content
                    this.modal.content.setAttribute('data-container','')
                    this.modal.content.innerHTML = `
                    <div class="container">
                        <div class="row">
                            <div class="col-12 col-md-auto headings">
                                <span class="h4 title">Privacy Policy</span>
                            </div>
                            <div class="content"></div>
                        </div>
                    </div>`
                    
                    let wrapper = this.modal.content.querySelector('.content')

                    wrapper.innerHTML = this.content
                    
                    // Build-up Modal
                    this.modal.section.append(this.modal.closer)
                    this.modal.section.append(this.modal.content)

                    // Append Modal to Body
                    app.content.append(this.modal.section)

                    // Add Toggler
                    this.toggler.setAttribute('data-modal-target',this.modal.section.id)
                    this.toggle(this.toggler)
                    this.close(this.modal.closer)
                }
            } else {
                console.warn(request.error)
            }
        // }
    }

    toggle(entry) {
        entry.onclick = (event) => {
            event.stopPropagation()
            event.preventDefault()

            let data_modal = entry.getAttribute('data-modal-target'),
                modal = document.querySelector('[id="' + data_modal + '"]')

            if (modal.hasAttribute('data-modal-video') || modal.hasAttribute('data-modal-gallery')) {
                const videos = modal.querySelectorAll('video');
                if (videos.length > 0) {
                    videos.forEach(video => {
                        video.pause();
                    });
                    document.body.classList.remove('modal-video--open');
                }
            }


            modal.classList.add('active')

            app.html.classList.add('scroll--off')
            app.root.classList.add('modal--open')

            modal.isOpen = true
            modal.current = data_modal
        }
    }

    close(entry) {
        let modals = document.querySelectorAll('.modal')

        entry.onclick = (event) => {
            event.stopPropagation()
            event.preventDefault()

            var modal = entry.parentNode

            if (modal.hasAttribute('data-modal-video') || modal.hasAttribute('data-modal-gallery')) {
                const videos = modal.querySelectorAll('video');
                if (videos.length > 0) {
                    videos.forEach(video => {
                        video.pause();
                    });
                    document.body.classList.remove('modal-video--open');
                }
            }


            modals.forEach((entry) => { entry.classList.remove('active') })

            app.html.classList.remove('scroll--off')
            app.root.classList.remove('modal--open')

            modal.isOpen = false
            modal.current = null
        }
    }

    onMouseEnter = (event) => { /** Code your own */ }

    onMouseLeave = () => { /** Code your own */ }

    destroy() {
        this.modals = document.querySelectorAll('[data-modal]')
        each(this.modals, (modal) => {

            modal.classList.remove('active')
            document.body.classList.remove('scroll--off')

            gsap.to(modal, {
                delay: .5,
                onComplete: modal.remove()
            })
        })
    }
}

export const PrivacyManager = new Privacy()